const pauseVideos = (root) => {
	root.querySelectorAll("video").forEach((video) => {
		video.pause();
		video.currentTime = 0;
		video.controls = false;
	});

	root.querySelectorAll(".platform__media.is-playing").forEach((media) => {
		media.classList.remove("is-playing");
	});
};

const setPanelState = (tabs, panels, nextIndex) => {
	tabs.forEach((tab, index) => {
		const selected = index === nextIndex;

		tab.classList.toggle("is-active", selected);
		tab.setAttribute("aria-selected", selected ? "true" : "false");
		tab.tabIndex = selected ? 0 : -1;
	});

	panels.forEach((panel, index) => {
		const selected = index === nextIndex;

		panel.classList.toggle("is-active", selected);
		panel.setAttribute("aria-hidden", selected ? "false" : "true");
		panel.hidden = !selected;
	});
};

const activateTab = (section, nextTab) => {
	const tabs = [...section.querySelectorAll('[role="tab"]')];
	const panels = [...section.querySelectorAll('[role="tabpanel"]')];
	const nextIndex = tabs.indexOf(nextTab);

	if (nextIndex < 0 || nextTab.classList.contains("is-active")) {
		return;
	}

	pauseVideos(section);
	setPanelState(tabs, panels, nextIndex);
};

const initSection = (section) => {
	const tabs = [...section.querySelectorAll('[role="tab"]')];

	tabs.forEach((tab) => {
		tab.addEventListener("click", () => {
			if (!tab.classList.contains("is-active")) {
				activateTab(section, tab);
			}
		});

		tab.addEventListener("keydown", (event) => {
			const current = tabs.indexOf(tab);
			let next = current;

			if (event.key === "ArrowDown" || event.key === "ArrowRight") {
				next = (current + 1) % tabs.length;
			} else if (event.key === "ArrowUp" || event.key === "ArrowLeft") {
				next = (current - 1 + tabs.length) % tabs.length;
			} else if (event.key === "Home") {
				next = 0;
			} else if (event.key === "End") {
				next = tabs.length - 1;
			} else {
				return;
			}

			event.preventDefault();
			activateTab(section, tabs[next]);
			tabs[next].focus();
		});
	});

	section.querySelectorAll(".platform__play").forEach((button) => {
		button.addEventListener("click", () => {
			const media = button.closest(".platform__media");
			const video = media?.querySelector("video");

			if (!media || !video) {
				return;
			}

			media.classList.add("is-playing");
			video.controls = true;
			video.play().catch(() => {});
		});
	});
};

const init = () => {
	document.querySelectorAll(".platform").forEach(initSection);
};

if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", init);
} else {
	init();
}
